<template>
  <div class="modal" data-backdrop="static" data-keyboard="false" id="add_table" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetTable"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="assign_table_modalLabel">Add New Table</h4>
        </div>
        <form @submit.prevent="addNewTable">
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Table Name</label>
                  <input
                      v-model="tableName"
                      type="text"
                      class="form-control"
                      required="required"
                      placeholder="Enter Name...">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button type="submit" class="btn btn-success pull-right">Add Table</button>
              </div>
            </div>
            <br/>
          </div>
        </form>
        <table class="table table-bordered table-hover table-stripped">
          <thead>
          <tr>
            <th class="text-center">ID</th>
            <th class="text-center">Table Name</th>
            <th class="text-center"><i class="fa fa-bolt"></i></th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(table, tableIndex) in tables">
            <tr :key="tableIndex + '_' + table.id" v-if="!table.deleted && !table.status && table.tableType===2">
              <td class="text-center">{{table.id}}</td>
              <td class="text-center">{{table.name}}</td>
              <th class="text-center"><button @click="deleteTable(table.id)" class="btn btn-danger btn-md"><i class="fa fa-times"></i></button></th>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
import {addTakeAwayNewTable, fetchTablesOfBranch} from "@/api/pos";
import {deleteBaykedCustomerAddress} from "@/api/customers";

export default {
  name: "AddNewTable",
  data(){
    return {
      tableName: '',
      table: {
        "id": 0,
        "name": "",
        "tableType": 2,
      }
    }
  },
  props : ['selectedBranch', 'tables'],
  methods: {
    load () {
      $("#add_table").modal("show");
    },
    fetchTables: async function() {
      let param = new URLSearchParams();
      param.append("branch_id", this.selectedBranch.id);
      const {data} = await fetchTablesOfBranch(param)
      this.$emit('updatedTableList', data)
    },

    async addNewTable() {
      try {
        this.table.name = this.tableName
        this.table.status = 0
        this.table.branch = this.selectedBranch
        await addTakeAwayNewTable(this.table)
        await this.fetchTables()
      } catch (e) {
        this.showErrorMessage(e)
      }
      this.resetTable()
      $("#add_table").modal("hide");
    },

    resetTable() {
      this.tableName = ''
    },

    deleteTable(tableId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete the Table?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete'
      }).then(async result => {
        if (result.value) {
          this.$http.delete(this.$store.state.mainAppURL + "tables/" + tableId).then(resp=>{
            Swal.close();
            this.fetchTables();
            Swal("Deleted","Table Has Been Deleted", "success");
          })
        }
      });
    },

  }
}
</script>

<style scoped>

</style>